"use client";

import { Link } from "@repo/next-utils/router";
import * as Container from "@repo/ui/container";
import * as Viewport from "@/components/viewport";
import { STRINGS } from "@/constants";
import {
  TYPOGRAPHY_BODY3_SENTENCE,
  TYPOGRAPHY_HEADING1,
  TYPOGRAPHY_LINK2_CAPS,
} from "@/theme/topshop/typography/typography-constants";
import { getErrorMessage } from "@/utils/error-messages";

import classes from "./error-message.module.css";

type ErrorMessageProps = {
  title: React.ReactNode;
  message: string;
  children?: React.ReactNode;
};

export const ErrorMessage = ({
  errorCode,
  title,
  message,
  children,
}: { errorCode?: string } & ErrorMessageProps) => {
  const error = errorCode ? getErrorMessage(errorCode) : { title, message };

  const layout = (
    <>
      <h1 className={`${classes.title} ${TYPOGRAPHY_HEADING1}`}>
        {error.title}
      </h1>
      <div className={classes.messageContainer}>
        <p className={`${TYPOGRAPHY_BODY3_SENTENCE} ${classes.message}`}>
          {error.message}
        </p>
        <div className={classes.linkContainer}>
          <Link href="/topshop" className={TYPOGRAPHY_LINK2_CAPS}>
            {STRINGS.nav.shopTopshop}
          </Link>

          <Link href="/topman" className={TYPOGRAPHY_LINK2_CAPS}>
            {STRINGS.nav.shopTopman}
          </Link>
        </div>
      </div>
    </>
  );

  return (
    <>
      <Viewport.Large>
        <Container.Root size="medium" gutter="3xl">
          {layout}
          {children && <>{children}</>}
        </Container.Root>
      </Viewport.Large>
      <Viewport.Small>
        <Container.Root size="medium" gutter="xl">
          {layout}
          {children && <>{children}</>}
        </Container.Root>
      </Viewport.Small>
    </>
  );
};
